<template>
<div class="contentBox demandAddPage">
    <div class="pageTitle">
        <h1>新建点播</h1>
    </div>
    <div class="certificationInfoBox">
        <div class="infoItem">
            <span class="title">标题</span>
            <el-input class="w600 titleInput " v-bind:class="{errorPrompt:errorTitle}" placeholder="请输入文字" v-model.trim="vodData.title" />
            <span v-if="errorTitle" class="errorHint">标题不能为空</span>
        </div>
        <div class="infoItem">
            <span class="title">海报</span>
            <div class="uploadImgBox">
                <el-form :model="form">
                    <el-form-item>
                        <el-upload ref="upload"
                            action="#" 
                            accept="image/png,image/gif,image/jpg,image/jpeg" 
                            list-type="picture-card"
                            :auto-upload="false" 
                            :on-exceed="handleExceed"
                            :file-list="posterList"
                            :on-preview="handlePictureCardPreview" 
                            :on-remove="handleRemove"
                            :on-change="handleChangePic"
                         style="float: left;margin-left: 15px">
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                            <span class="uploadTips">上传图片</span>
                        </el-upload>

                        <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="infoItem">
            <span class="title">类型</span>
            <div class="userType">
                <el-select v-model="vodData.typeId" placeholder="请选择" class="selectType">
                    <el-option v-for="item in demandOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
        </div>
        <div class="infoItem">
            <span class="title">简介</span>
            <froala :tag="'textarea'" :config="config" v-model="vodData.intro"></froala>
        </div>
    </div>
    <div class="advancedDemand" :style="{ height: advancedIsShow ? '190px' : '40px' }">
        <div class="title">
            <span>高级</span>
            <div id="roundArrow" :class="[advancedIsShow ? 'down' : 'up']" @click="toggleAdvanced"></div>
        </div>
        <div class="advancedInfo">
            <div class="infoItem">
                <span class="label">公开</span>
                <el-switch v-model="vodData.isOpen" :active-value="1" :inactive-value="0" active-color="#306FF6" inactive-color="#C1C5C5"></el-switch>
                <span v-if="vodData.isOpen === 0" class="passwordTips">观看密码：</span>
                <el-input v-if="vodData.isOpen === 0" v-model="vodData.password" class="password"></el-input>
            </div>

            <div class="infoItem">
                <span class="label">隐私</span>
                <template>
                    <el-radio-group v-model="vodData.visible">
                        <el-radio :label="1">Quicklive显示</el-radio>
                        <el-radio :label="0">Quicklive不显示</el-radio>
                    </el-radio-group>
                </template>
            </div>
        </div>
    </div>
    <div class="actionBtnBox">
        <button class="submitBtn" @click="saveVod">提交</button>
        <a id="file_selector" href="javascript:void(0);" style="display: none">uploader</a>
    </div>
</div>
</template>

<script>
    import common from '../../common.vue';
    import OSS from 'ali-oss';

    const GET_VOD_TYPE_URL = common._BASE_ + 'lt/getAll';
    export default {
        name: "DemandEdit",
        data() {
            return {
                vodId: -1,
                vodData: {visible: 1, isOpen: 1},
                // 内容是否更改
                vodChanged : false,
                demandOptions: [],
                demandEditRadio: "show",
                advancedIsShow: true,
                dialogImageUrl: '',
                dialogVisible: false,
                form: {},

                errorTitle: false,

                // 成功上传的海报列表
                posterList: [],
                // 选择的海报文件
                posterFile: null,
                // oss上传配置
                ossConfig: {},
                // 如果上传新海报，海报的在oss上的路径
                posterPath: null,

                // html编辑器
                editor: null,
                config: {
                    attribution: false,
                    language: 'zh_cn',
                    imageUploadParam: "file",
                    imageMaxSize: 1024 * 1024 * 10,  //限制10MB大小
                    imageUploadURL: common._BASE_ + "content/uploadImage",
                    imageUploadParams: {fileName: ""},
                    imageDefaultWidth: 414,
                    events: {
                        initialized: function (e, editor) {
                            this.editor = editor;
                            console.log('froala editor initialized')
                        },
                        focus: function () {
                            console.log('froala editor focused');
                        }
                    }
                },
            };
        },
        methods: {
            loadLiveType() {
                let _this = this;
                _this.$axios.post(GET_VOD_TYPE_URL).then(function (res) {
                    console.log(res);
                    if (/*res.code===0&&*/res.data) {
                        let ops = res.data.data;
                        for (let i = 0; i < ops.length; i++) {
                            _this.demandOptions.push({value: ops[i].typeId, label: ops[i].typeName});
                        }
                    }


                });

            },
            /**
             * 上传文件
             * @param file
             * @param callback
             */
            ossUploadFile(file, callback){
                if(!file){ return null; }

                let _this = this,
                    ossClient = new OSS(this.ossConfig),
                    fileName = common.guid() + "." + common.fileExt(file.name),
                    ossKey = common.assertPath(this.ossConfig.folder) + fileName;
                ossClient.put(ossKey, file).then(function(r){
                    console.info(r);
                    callback && callback(ossKey);
                }).catch(function (err) {
                    console.error('error: %j', err);
                    _this.$notify({
                        title: '错误',
                        message: err,
                        type: 'error'
                    });
                    return null;
                });
            },

            saveVod() {
                let _this = this;
                if (_this.checkInput()) {
                    // 如果有海报需要上传
                    if(_this.posterFile){
                        _this.ossUploadFile(_this.posterFile,function (ossKey) {
                            _this.posterPath = ossKey;
                            _this.doSave();
                        });
                    }else{
                        _this.doSave();
                    }
                }
            },
            doSave() {
                let _this = this;
                if (_this.posterPath && _this.posterPath !== '') {
                    _this.vodData.poster = _this.posterPath;
                }
                _this.$axios.post(common._BASE_ + '/vod/saveVod', this.$qs.stringify(_this.vodData)).then(function (res) {
                    let r = res.data;
                    if(r && r.code === 0){
                        _this.vodChanged = false;
                        _this.$router.push('/onDemand/list');
                    }else{
                        _this.$message({message: "保存失败，请重新登录后重试。", type: 'error'});
                    }
                });
            },
            // 检查频道信息是否合法
            checkInput() {
                let v = this.vodData;
                // 标题
                if (!v.title || v.title === '') {
                    this.$message({
                        message: '请输入点播标题',
                        type: 'warning'
                    });
                    return false;
                }
                if (!v.typeId || parseInt(v.typeId) < 0) {
                    this.$message({
                        message: '请选择类型',
                        type: 'warning'
                    });
                    return false;
                }
                if ((!v.vodId || v.vodId < 0) && !this.posterFile) {
                    this.$message({
                        message: '请为点播选择海报',
                        type: 'warning'
                    });
                    return false;
                }


                return true;
            },
            toggleAdvanced() {
                this.advancedIsShow = !this.advancedIsShow;
            },

            // 新上传的图片替换老的图片
            handleChangePic(file, fileList) {
                if (fileList.length > 1) {
                    fileList.splice(0, 1);
                }
                this.posterFile = file.raw;
                this.vodChanged = true;
            },
            // 文件超出个数限制时的钩子
            handleExceed() {
                alert('只可以上传一个文件');
            },
            // 文件列表移除文件时的钩子
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            // 点击文件列表中已上传的文件时的钩子
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            // 上传图片到服务器
            uploadFile() {
                this.$refs.upload.submit()
            },
            getCredential(callback){
                let _this = this;

                _this.$axios.post(common.OSS_CREDENTIAL_URL).then(function (res) {
                    let r = res.data;
                    if (r && r.code === 0) {
                        callback && callback(r);
                    }
                    r.code < 0 && _this.jumpPage('/login');
                });
            },
            /**
             * 根据服务器上返回的授权构建oss配置
             */
            buildConfig(credential){
                let _this = this;
                _this.ossConfig = Object.assign({
                    refreshSTSToken: async () => {
                        _this.getCredential(function(r){
                            return r;
                        });
                    }
                }, credential);
            },

            jumpNavPage(path) {
                this.$router.push({
                    path: path+'/'+this.vodId
                });
            }
        },

        mounted() {
            let _this = this;
            _this.loadLiveType();
            _this.getCredential(function (c) {
                _this.buildConfig(c);
            });
            _this.$parent.openKey = 2;
            _this.$parent.$refs.mainMenu.activeIndex = '2-2';
        },
        watch: {
            'vodData.title': function (title) {
                let _this = this;
                _this.errorTitle = (title.length === 0);
            },
            'vodData': {
                handler () {
                    this.vodChanged = true;
                },
                deep: true
            }
        },
        beforeRouteLeave: function(to, from , next) {
            if(this.vodChanged){
                this.$confirm("确定离开页面吗？未保存内容将丢失。","确认",{
                    iconClass: "el-icon-question",
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    showClose: true,
                    type: "warning",
                }).then(function(){
                    next();
                });
            }else{
                next();
            }
        }
    };
</script> 

<style lang="less">
.demandAddPage {
    .uploadView{
      width: 180px;
    }
    .pageTitle {
        margin-bottom: 20px;

        h1 {
            height: 20px;
            line-height: 24px;
            font-size: 20px;
            font-weight: bold;
            color: #221816;
        }
    }

    .certificationInfoBox {
        width: 1210px;
        background: #ffffff;
        border: 1px solid #e8e8e8;
        padding: 30px 0 10px 32px;
        font-size: 14px;

        .infoItem {
            display: flex;
            margin-bottom: 22px;
        }

        .downloadItem {
            margin-bottom: 9px;
        }

        .w600 {
            width: 600px;
        }

        .title {
            width: 74px;
            line-height: 28px;
        }

        .titleInput .el-input__inner::-webkit-input-placeholder {
            font-size: 14px;
            color: #c0c5c5;
        }

        .userType {
            .el-select .el-input__inner::-webkit-input-placeholder {
                color: #33363f;
            }

            .el-select .el-input__inner::-moz-input-placeholder {
                color: #33363f;
            }

            .el-select .el-input__inner::-ms-input-placeholder {
                color: #33363f;
            }
        }

        .errorHint {
            height: 40px;
            font-size: 14px;
            line-height: 40px;
            color: #dc5986;
            margin-left: 16px;
        }

        .uploadImgBox {
            width: 800px;
            height: 160px;
            position: relative;

            .el-upload--picture-card {
                width: 240px;
                height: 148px;
                background: #f5f6f7;
                border: 1px solid #c1c5c5;
                border-radius: 4px;
                position: relative;
                cursor: pointer;

                .uploadTips {
                    width: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 10;
                    color: #a2a9ab;
                    text-align: center;
                    padding-top: 26px;
                }
            }

            .el-upload--picture-card:hover {
                border-color: #409eff;

            }

            .el-upload-list--picture-card {
                .el-upload-list__item-thumbnail {
                    width: 100%;
                    height: auto;
                }
            }
        }

        .switchTips {
            margin-left: 10px;
        }
    }

    .introText {
        height: 120px;
    }

    .el-textarea.introText .el-textarea__inner {
        padding: 10px;
        font-size: 14px;
    }

    .el-textarea.introText .el-textarea__inner::-webkit-scrollbar {
        width: 4px;
        border-radius: 4px;
        background: #f5f6f7;
    }

    .el-textarea.introText .el-textarea__inner::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #076eff;
        border-radius: 4px;
    }

    .el-textarea.introText .el-textarea__inner::-webkit-input-placeholder {
        color: #c0c5c5;
    }

    .advancedDemand {
        width: 1210px;
        height: 190px;
        overflow: hidden;
        background: #ffffff;
        border: 1px solid #e8e8e8;
        margin: 15px 0;

        .title {
            height: 44px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #e9e9e9;
            padding: 0 21px;
            font-size: 16px;
            font-weight: bold;
            color: #221816;

            span::before {
                content: "";
                display: inline-block;
                width: 4px;
                height: 12px;
                background: #306ff6;
                border-radius: 3px;
                margin-right: 6px;
            }
        }

        .infoItem {
            display: flex;
            align-items: center;
            margin-bottom: 22px;
            margin-bottom: 17px;
        }

        .downloadItem {
            margin-bottom: 9px;
        }

        .w600 {
            width: 600px;
        }

        .label {
            width: 74px;
            font-size: 14px;
            font-weight: 400;
            line-height: 50px;
            color: #221816;
        }

        .advancedInfo {
            padding: 16px 32px;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            color: #221816;
        }

        .passwordTips {
            margin-left: 21px;
            margin-right: 10px;
        }

        .password {
            width: 151px;
        }

        .confirmBtn {
            width: 61px;
            height: 40px;
            background: #076eff;
            border-radius: 4px;
            color: #ffffff;
            margin-left: 5px;
        }

        .confirmBtn:hover {
            background: #4aa3f8;
        }
    }

    #roundArrow {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: url("../../assets/round-arrow-gary.svg") no-repeat center center;
        background-size: 100% 100%;
        transition: all 0.2s;
        -webkit-transition: all 0.2s;
        cursor: pointer;
    }

    #roundArrow:hover {
        background: url("../../assets/round-arrow-blue.svg") no-repeat center center;
        background-size: 100% 100%;
    }

    #roundArrow.up {
        transform: rotate(180deg);
        -webkit-transform: rotate(180deg);
    }

    .actionBtnBox {
        button {
            width: 110px;
            height: 40px;
            border-radius: 4px;
            font-size: 14px;
        }

        .resetBtn {
            background: #ffffff;
            border: 1px solid #c1c5c5;
        }

        .resetBtn:hover {
            background: #306ff6;
            color: #fff;
            border: none;
        }

        .submitBtn {
            background: #076eff;
            color: #fff;
            margin-right: 22px;
        }

        .submitBtn:hover {
            background: #4aa3f8;
        }
    }
}
</style>
